module.exports = __webpack_public_path__ + "static/OldMansJourney0-e4fbf172f1dff716908acb28d26008c9.webp";